export const getNegExecution = (fetch: Client.HttpClient) => () =>
  fetch.get<Sentinel.NegExecution.Response>("/api/neg-execution");
